import { useQuery } from '@tanstack/react-query';

const TRUSTED_IPS = ['181.224.250.149', '192.168.1.1'];
const TRUSTED_RANGES = ['192.168.0.0/16', '10.0.0.0/8'];

const ipToLong = (ip: string) => ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);

function isTrustedIP(ip: string): boolean {
  if (!ip || ip === '::1') return false;

  const ipLong = ipToLong(ip);
  const isInRange = TRUSTED_RANGES.some((range) => {
    const [rangeIp, bits] = range.split('/');
    const mask = ~(2 ** (32 - parseInt(bits, 10)) - 1);
    return (ipToLong(rangeIp) & mask) === (ipLong & mask);
  });

  return TRUSTED_IPS.includes(ip) || isInRange;
}

export const useUserIp = () => {
  return useQuery({
    queryKey: ['user-ip'],
    queryFn: async () => {
      const res = await fetch('https://api.ipify.org/?format=json');
      if (!res.ok) throw new Error('Error al obtener IP');
      const data = await res.json();
      return data.ip as string;
    },
    select: (ip) => ({
      ip,
      isTrusted: isTrustedIP(ip),
    }),
    staleTime: 1000 * 60 * 60, // Conservar la IP en caché por 1 hora
    retry: 1,
  });
};
